export const SS_GEOLOCATION_TIMED_OUT = 'flashChat_geolocationTimedOut';
